/* eslint-disable */
import React from 'react';
import CadastrarProtocolo from './CadastrarProtocolo';

//Atalho da rota /UPP (ex.: https://host/AppForm/UPP).
//Só injeta os params equivalentes a /cadastrarProtocolo/upp/ouvidoria/geral/NA.
//As regras do UPP (UF Sebrae Nacional travada, natureza Sugestão fixa e
//canal de entrada 136) ficam em CadastrarProtocoloForm.js, chaveadas no canal 'upp'.
const CadastrarProtocoloUPP = (props) => (
    <CadastrarProtocolo {...props} params={Object.assign({}, props.params, { canal: 'upp', grupo: 'ouvidoria', natureza: 'geral', uf: 'NA' })} />
);

export default CadastrarProtocoloUPP;



/** WEBPACK FOOTER **
 ** ./src/components/CadastrarProtocoloUPP.js
 **/